// src/utils/dialog.js
//
// Promise-based dialogs rendered by <DialogHost /> (mounted once in App.js).
// Replaces window.confirm / window.prompt and the Notiflix Report / Confirm.
//
//   const ok = await dialog.confirm({ title, message, confirmLabel, tone: "danger", typeToConfirm: "RELEASE" });
//   const values = await dialog.prompt({ title, fields: [{ name, label, defaultValue, type, required, validate }] });
//   await dialog.alert({ title, message, tone: "warning" });
let listener = null;
const pending = [];
let seq = 0;

const emit = () => {
  if (listener) listener(pending.slice());
};

export const dialogStore = {
  subscribe(fn) {
    listener = fn;
    emit();
    return () => {
      if (listener === fn) listener = null;
    };
  },
  resolve(id, value) {
    const i = pending.findIndex((d) => d.id === id);
    if (i === -1) return;
    const [item] = pending.splice(i, 1);
    emit();
    item.resolve(value);
  },
};

const open = (kind, spec, fallback) =>
  new Promise((resolve) => {
    // If the host is not mounted (e.g. a unit test), fail safe: never auto-confirm.
    if (!listener && typeof window !== "undefined" && !window.__eeDialogHostMounted) {
      resolve(fallback);
      return;
    }
    pending.push({ id: ++seq, kind, spec, resolve });
    emit();
  });

export const dialog = {
  /** resolves true / false */
  confirm: (spec) => open("confirm", spec || {}, false),
  /** resolves an object of field values, or null if cancelled */
  prompt: (spec) => open("prompt", spec || {}, null),
  /** resolves when dismissed */
  alert: (spec) => open("alert", spec || {}, undefined),
};

export default dialog;
